import React from 'react';
import '../../styles/GSIDA.css';

export default function GSIDATheme() {
  return (
    <div className="gsida-theme-page">
      <div className="gsida-header-banner theme-banner">
         <div className="banner-overlay">
            <h1>Thème 2026</h1>
            <p>Intelligence Artificielle et Gouvernance Résiliente : Quel Modèle pour l'Afrique ?</p>
         </div>
      </div>

      <div className="gsida-content-container">
        <section className="theme-card-main">

         <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Vision du Thème</h3>
          </div>

          
          <p>
            Pour son édition 2026, le Congrès GSIDA place la <strong>convergence technologique</strong> au cœur du débat. L'objectif est d'explorer comment l'Intelligence Artificielle peut transformer radicalement les architectures de gouvernance sécuritaire tout en préservant la souveraineté nationale et les droits fondamentaux.
          </p>
          <div className="theme-axis">

            <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Axes Thématiques de l'Édition 2026</h3>
          </div>

         
             <div className="axis-grid">
                <div className="axis-item">
                   <span className="dot"></span>
                   <p><strong>IA & Sécurité Nationale :</strong> Automatisation de la surveillance et analyse préventive des risques.</p>
                </div>
                <div className="axis-item">
                   <span className="dot"></span>
                   <p><strong>Souveraineté Numérique :</strong> Protection des infrastructures critiques et gestion des données stratégiques.</p>
                </div>
                <div className="axis-item">
                   <span className="dot"></span>
                   <p><strong>Défis Éthiques :</strong> Cadres réglementaires et responsabilité algorithmique dans les administrations publiques.</p>
                </div>
                <div className="axis-item">
                   <span className="dot"></span>
                   <p><strong>Inclusion Technologique :</strong> Comment l'IA peut-elle favoriser un développement sécuritaire équitable ?</p>
                </div>
             </div>
          </div>
        </section>
      </div>
    </div>
  );
}
